import styled from 'styled-components';

import { Grid } from 'coreOld/elements';

const InputsWrapper = styled(Grid)`
  margin: 0px;
  margin-bottom: 10px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  align-items: center;
  padding: 5px 16px 5px 32px;

  :last-child {
    border-bottom: none;
  }
`;

export default InputsWrapper;
